import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import { useForm } from 'react-hook-form'
import TextInput from './inputs/text-input'
import SelectInput from './inputs/select-input'
import CheckInput from './inputs/check-input'
import LogoInput from './inputs/logo-input'
import { patchForm, postForm } from '../../ajax'
import FlashAlert from '../../components/flash-alert'

function FormModal({data, onClose, onCreate, onUpdate}) {
  const isNew = !data.id
  const requiredMsg = 'Is required'
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState()
  const { register, reset, setValue, getValues, handleSubmit, formState: { errors } } = useForm()
  const [fileLoaded, setFileLoaded] = useState(false)
  const logoUrl = getValues('logo_url')
  const kindOptions = ['Organization', 'Brand/Corporation', 'Other']

  useEffect(() => {
    reset(_.omit(data, 'id'))
  }, [data])

  const validatePresence = (value) => {
    if (!value.trim()) return requiredMsg
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) { if (data[key] != null && data[key] != 'undefined') formData.append(`partner[${key}]`, data[key]) }
    return formData
  }

  const submitUrl = () => {
    if (isNew) return `/admins/partners.json`

    return `/admins/partners/${data.id}.json`
  }

  const onSubmit = async (data) => {
    let formData = prepareFormData(data)
    const submitMethod = isNew ? postForm : patchForm

    setLoading(true)
    const response = await submitMethod(submitUrl(), formData)
    const json = await response.json()
    setLoading(false)
    if (json.alert)
      setAlert(json.alert)
    else {
      const partner = json.partner
      isNew ? onCreate(partner) : onUpdate(partner)
    }
  }

  const loadFile = (file) => {
    const fr = new FileReader()
    fr.onloadend = function() { 
      setValue('logo_url', fr.result)
      setFileLoaded(file.name)
    }
    fr.readAsDataURL(file)
  }

  const fileSelected = (file) => {
    if (file.size > 10000000) return window.alert('File size limit is 10MB')    
    if (file.type != 'image/png') return window.alert(' Only PNG files are allowed')

    loadFile(file)
  }

  return (
    <Modal dialogClassName='partner-modal' backdrop='static' container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? 'New Organizer' : 'Edit Organizer'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} /> }
        { loading && <div className='animated-spinner'></div> }
        <form className={'partner-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            {...register('name', { required: 'Is required', validate: validatePresence })}
            label='Name'
            error={errors && errors.name}
            onChange={e => setValue('name', e.target.value)}
          />
          <TextInput
            {...register('email', {
              required: 'Is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address'
              }
            })}
            label='Support Email'
            error={errors && errors.email}
            onChange={e => setValue('email', e.target.value)}
          />
          <SelectInput
            {...register('kind')}
            label='Type'
            options={kindOptions}
            error={errors && errors.kind}
            onChange={e => setValue('kind', e.target.value)}
          />
          <CheckInput
            {...register('default')}
            label='Default'
            onChange={e => setValue('default', e.target.checked)}
          />
          <LogoInput logoUrl={logoUrl} onFileLoad={fileSelected} />
          <div className='form-action'>
            <input type='submit' value={isNew ? 'Create' : 'Update'} className='btn btn-primary' />
            <button className='btn btn-default' onClick={onClose} type='button'>Cancel</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}

FormModal.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}

export default FormModal

